<div class="row">
  <div class="col-12">
    <img *ngIf="!hideJumbo" src="assets/images/reports_jumbo.png" class="mb-3 jumbo-img" />
  </div>
  <div class="col-12">
    <h3>View Past Paystubs!</h3>
  </div>
</div>
<div class="row" *ngIf="years != null">
  <div class="col-4">
    <select
      data-testid="yearSelect"
      class="form-control"
      [ngModel]="chosenYear"
      (ngModelChange)="yearChanged($event)"
      required>
      <option [value]="null" disabled>Select Year</option>
      <option *ngFor="let year of years" [ngValue]="year">{{ year.Year }}</option>
    </select>
  </div>
  <div class="col-4" *ngIf="chosenYear != null">
    <select
      data-testid="payDateSelect"
      [ngModel]="chosenPayDate"
      (ngModelChange)="paydateChanged($event)"
      class="form-control"
      required>
      <option [value]="null" disabled>Select Pay Date</option>
      <option *ngFor="let paydate of paydates | async" [ngValue]="paydate">
        {{ paydate.Paydate | date: 'MM/dd/yyyy' }}
      </option>
    </select>
  </div>
  <div class="col-4"></div>
</div>
<hr *ngIf="fetchedPaylines != null" />
<div class="row mb-3" *ngIf="fetchedPaylines != null">
  <div class="col-12">
    <h3>Select Employee</h3>
  </div>
</div>
<div class="row mb-3" *ngIf="fetchedPaylines != null">
  <div class="col-8">
    <div class="list-group">
      <div class="list-group-item list-group-item-secondary">
        <div class="row">
          <div class="col-1">
            <lib-checkbox
              [ngModel]="selectAll"
              (ngModelChange)="selectAllChanged($event)"
              [id]="'chk_all'"
              [size]="checkSizes.Small"></lib-checkbox>
          </div>
          <div class="col-5 fw-bold">Name</div>
          <div class="col-3 fw-bold">Employee #</div>
          <div class="col-3 fw-bold">Net Pay</div>
        </div>
      </div>
      <div class="list-group-item" *ngFor="let fetched of fetchedPaylines">
        <div class="row">
          <div class="col-1">
            <lib-checkbox
              [ngModel]="fetched.Selected"
              (ngModelChange)="checkChanged($event, fetched)"
              [id]="'chk_' + fetched.PaylineId"
              [size]="checkSizes.Small"></lib-checkbox>
          </div>
          <div class="col-5">
            <span *ngIf="!canAccessPeople">{{ fetched.Name }}</span>
            <button
              *ngIf="canAccessPeople"
              class="btn btn-link-blue p-0"
              (click)="personLinkClicked(fetched)">
              {{ fetched.Name }}
            </button>
          </div>
          <div class="col-3">
            {{ fetched.PersonId }}
          </div>
          <div class="col-3">
            {{ fetched.NetPay | currency }}
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <lib-pagination
            [pagination]="pagination"
            (pageChanged)="pageChanged($event)"></lib-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
<lib-report-buttons
  [downloadButtonStyle]="'btn-primary'"
  [customDownloadButtonText]="'View Paystub'"
  (downloadReport)="reportGenerate()"
  [allowHtml]="false"
  [formats]="downloadFormats"
  [disabled]="selectedLines.length === 0"></lib-report-buttons>
